<script>
  let { class: clazz } = $props()
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="64"
  height="64"
  viewBox="0 0 24 24"
  aria-hidden="true"
  class={clazz}
>
  <path
    d="M0 0h64v64H0V0z M0 24a24 24 0 0 1 24-24v24H0z"
    fill="currentColor"
    fill-rule="evenodd"
  />
</svg>
